import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export interface ButtonProps {
  label: string;
  buttonName?: string;
  linkUrl: string;
}

export const Button = ({
  label,
  buttonName,
  linkUrl,
}: ButtonProps): ReactElement => {
  const { t } = useTranslation();

  const onButtonClick = () => {
    window.open(linkUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="final-screen__item">
      <div className="final-screen__text">{t(label)}:</div>
      <div className="final-screen__text">
        <button
          className="final-screen__button final-screen__button--secondary"
          type="button"
          onClick={() => onButtonClick()}
        >
          {t(buttonName || 'Click')}
        </button>
      </div>
    </div>
  );
};
